import { sectionOf, type ScreenManifest, type ScreenRegistry } from '@/shared/screen';

// U24: login, MFA, step-up e Segurança são sempre manuais; as telas já levam `agent: false`, e isto é a
// segunda trava, por rota e por seção.
const MANUAL_ONLY_PATHS: readonly string[] = ['/login', '/seguranca', '/meu-perfil'];
const MANUAL_ONLY_SECTIONS: ReadonlySet<string> = new Set(['security']);

/** Tela que nenhum agente abre nem opera, além do `agent: false`: Segurança, login, MFA e perfil (U24, U56). */
export function isManualOnlyScreen(registry: ScreenRegistry, screen: ScreenManifest): boolean {
  if (MANUAL_ONLY_SECTIONS.has(sectionOf(registry, screen) ?? '')) return true;
  return MANUAL_ONLY_PATHS.some((path) => screen.path === path || screen.path.startsWith(`${path}/`));
}
